import React from "react";
import {DimensionValue, ScrollView, TextInput, TouchableOpacity, View} from "react-native";
import AppText from "./AppText";
import HideableView from "./HideableView";
interface IProps{
  width:DimensionValue;
  placeholder:string;
  options:any[]
    onValueChange:Function
    openCallBack:Function
}
export default class FilterableInput extends React.Component<IProps>{
    state={
        isOpened:false,
        filter:''
    }
    getOptions(){
        if(this.state.filter=='')
            return  this.props.options
        let str=''
        return this.props.options.filter(o=>o.label.startsWith(this.state.filter))
    }
    render() {
        return(
            <View style={{width:this.props.width,position:'relative',zIndex:100, elevation: 5}}>

                <TextInput onChangeText={text => {
                    if(text.length>0){
                        this.setState({isOpened:true})
                        this.props.openCallBack(true)
                    }
                    this.setState({filter:text})
                }} value={this.state.filter} onFocus={()=>{
                    this.props.openCallBack(!this.state.isOpened)
                    this.setState({isOpened:!this.state.isOpened})
                }} placeholderTextColor={'#989898'}  style={{height:30,paddingTop:1,paddingBottom:1,width:'100%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={this.props.placeholder}/>
                <HideableView hidden={!this.state.isOpened} style={{width:'100%',height:100,position:'absolute',left:2,top:32,zIndex:100, elevation: 15}}>
                    <View style={{width:'98%',height:120,backgroundColor:'#01B271', elevation: 5}}>
                        <TouchableOpacity style={{elevation:5,zIndex:100,width:30,height:30,justifyContent:'center',alignItems:'center'}} onPress={()=>this.setState({isOpened:false})}>
                            <AppText style={{fontSize:18,marginTop:5,marginLeft:5,alignSelf:'flex-start'}}>X</AppText>
                        </TouchableOpacity>
                        <ScrollView style={{width:'100%',height:100,paddingLeft:10,paddingRight:10,paddingTop:0,marginBottom:0, elevation: 15}}>
                            {
                                this.getOptions().map(o=>{
                                    return <TouchableOpacity style={{elevation:5,zIndex:100,width:'50%'}} onPress={()=>{
                                        this.setState({isOpened:false,filter:o.label})
                                        this.props.onValueChange(o.value)
                                        this.props.openCallBack(false)
                                    }}>
                                        <AppText style={{width:'100%',textAlign:'left',marginLeft:10,fontSize:16,color:'white'}}>{o.label}</AppText>
                                    </TouchableOpacity>
                                })
                            }
                        </ScrollView>
                    </View>

                </HideableView>
            </View>
        )
    }
}
